import { AES, enc } from 'crypto-js';
import { ClientJS } from 'clientjs';


const getClientFingerPrint=() => {
  const client = new ClientJS();
  return ''+client.getFingerprint();
};

export const setEncryptSessionStorage = (key, value) => {
  const encryptedString = AES.encrypt(value, getClientFingerPrint() );
  sessionStorage.setItem(key, encryptedString.toString());
};

export const getEncryptSessionStorage = (key) => {
  if (sessionStorage.getItem(key)) {
    const decrypted = AES.decrypt(sessionStorage.getItem(key), getClientFingerPrint() );
    return decrypted.toString(enc.Utf8);
  }
  return null;
};

export const setEncryptLocalStorage = (key, value) => {
  const encryptedString = AES.encrypt(value, getClientFingerPrint() );
  localStorage.setItem(key, encryptedString.toString());
};

export const getEncryptLocalStorage = (key) => {
  if (localStorage.getItem(key)) {
    const decrypted = AES.decrypt(localStorage.getItem(key) ,getClientFingerPrint() );
    return decrypted.toString(enc.Utf8);
  }
  return null;
};
